import { Link } from "react-router-dom";
import { ArrowRight, FileCode2, Braces, Globe, Cpu, Coffee, Sparkles, TerminalSquare, AppWindow, ShieldCheck, ClipboardList, Server, MonitorSmartphone, FileCode, Factory } from "lucide-react";

const ICONS = {
  python: FileCode2,
  javascript: Braces,
  "html-css": Globe,
  cpp: Cpu,
  java: Coffee,
  "ki-prompting": Sparkles,
  "linux-befehle": TerminalSquare,
  "windows-themen": AppWindow,
  "it-sicherheit": ShieldCheck,
  projektmanagement: ClipboardList,
  "php-programmierung": Server,
  "pc-technologie": MonitorSmartphone,
  "xml-programmierung": FileCode,
  "pearl-programmierung": Factory,
};

export default function CourseCard({ course, progress }) {
  const Icon = ICONS[course.slug] || FileCode2;
  const done = progress?.done ?? 0;
  const total = progress?.total ?? course.lesson_count;
  const pct = total ? Math.round((done / total) * 100) : 0;

  return (
    <Link
      to={`/kurs/${course.slug}`}
      data-testid={`course-card-${course.slug}`}
      className="nb-card nb-press p-6 flex flex-col gap-4 group"
    >
      <div className="flex items-start justify-between">
        <div
          className="h-14 w-14 rounded-xl border-2 border-black flex items-center justify-center nb-shadow-sm"
          style={{ backgroundColor: course.color }}
        >
          <Icon className="h-7 w-7 text-black" strokeWidth={2.5} />
        </div>
        <span className="text-[11px] font-bold uppercase tracking-wide bg-muted border-2 border-black rounded-full px-2.5 py-0.5">
          {course.level}
        </span>
      </div>

      <div>
        <h3 className="font-heading font-black text-2xl tracking-tight">{course.title}</h3>
        <p className="text-muted-foreground text-sm font-medium mt-0.5">{course.subtitle}</p>
      </div>

      <p className="text-sm leading-relaxed flex-1">{course.description}</p>

      <div>
        <div className="flex items-center justify-between text-xs font-bold mb-1">
          <span>{done}/{total} Lektionen</span>
          <span>{pct}%</span>
        </div>
        <div className="h-3 w-full bg-white border-2 border-black rounded-full overflow-hidden">
          <div
            className="h-full bg-success transition-all duration-500"
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>

      <div className="flex items-center gap-1 font-bold text-sm text-primary">
        Loslegen
        <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" strokeWidth={2.5} />
      </div>
    </Link>
  );
}
